/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Wpm_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum Words Per Minute (WPM)" |
*
* @param {Style_Guide_Manager_Min_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_wpm_label = /** @type {((inputs?: Style_Guide_Manager_Min_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mots minimum par minute (WPM)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestwortzahl pro Minute (WPM)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero minimo di parole al minuto (WPM)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальная скорость печати (слов в минуту)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Palabras mínimas por minuto (WPM)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟最低字数 (WPM)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1分あたりの最小単語数（WPM）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम शब्द प्रति मिनट (WPM)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número mínimo de palavras por minuto (PPM)")
	return /** @type {LocalizedString} */ ("Minimum Words Per Minute (WPM)")
});